import { TFunction } from 'react-i18next';
import { SMART_CONNECTOR_STATUSES } from './constants';
import { SmartConnectorStatus, SmartConnectorType } from './types';

export const getIsSmartConnectorActive = ({
  status,
}: {
  status: SmartConnectorStatus;
}) => {
  return (
    [
      SMART_CONNECTOR_STATUSES.operational,
      SMART_CONNECTOR_STATUSES.need_attention,
    ] as SmartConnectorStatus[]
  ).includes(status);
};

export const getSmartConnectorStatusesConfig = (t: TFunction) => ({
  [SMART_CONNECTOR_STATUSES.setup]: {
    label: t('Setup In Progress'),
    color: 'var(--color-background-darker)',
  },
  [SMART_CONNECTOR_STATUSES.operational]: {
    label: t('Operational'),
    color: 'var(--color-viz-cat-1-primary)',
  },
  [SMART_CONNECTOR_STATUSES.need_attention]: {
    label: t('Operational (Needs Attention)'),
    color: 'var(--color-viz-cat-7-primary)',
  },
  [SMART_CONNECTOR_STATUSES.inactive]: {
    label: t('Inactive'),
    color: 'var(--color-viz-cat-3-primary)',
  },
});

export const getSmartConnectorTypeNames = (
  t: TFunction
): Record<SmartConnectorType, string> => ({
  spreadsheet: t('Spreadsheet Upload'),
  webhook: t('Webhook'),
  schedule: t('Schedule'),
  bulkaction: t('Bulk Action'),
  activity: t('Activity'),
  polling: t('Polling'),
  direct_api: t('Direct API'),
});
